export class CabangInfoViewModel {
    comloc_id: string;
    comloc_nama: string;
    perusahaan_id: string;
    perusahaan_nama: string;
}
